module.exports = __webpack_public_path__ + "img/primary_logo_bigger_dimensions.5eefa918.png";